const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.GADGETS_ORDERS)

const SHIPMENT_PREFIX = 'shipment'

export const apiGadgetsOrders = {
	fetchGadgetsOrders: async (
		search: IApiSearch = { query: '' },
		pagination: IApiPagination = { page: 1, perPage: 25 },
		filters?: IApiFilters,
		sorting?: ISortingOption,
	): Promise<IApiResponseModel<IGadgetsOrderModel[]>> => {
		const searchFilter = createSearchQuery(search.query, search.type)

		const { data, meta } = await apiCommon<IGadgetsOrder[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(
				pagination,
				{ ...filters, ...searchFilter },
				sorting ? { [sorting.key]: sorting.type } : undefined,
			),
		})

		return { data: data.map(GadgetsOrder), meta }
	},
	fetchGadgetsOrderDetails: async (orderId: number): Promise<IGadgetsOrderDetailsModel> => {
		const { data } = await apiCommon<IGadgetsOrderDetails>(`${groupPrefix}/${orderId}`, { method: 'GET' })

		return GadgetsOrderDetails(data)
	},
	fetchGadgetsOrdersFilters: async (): Promise<IGadgetsOrderFiltersModel> => {
		const { data } = await apiCommon<IGadgetsOrderFilters>(`${groupPrefix}/filters`, { method: 'GET' })

		return GadgetsOrderFilters(data)
	},
	generateGadgetsOrderShipmentLabel: async (orderId: number): Promise<void> => {
		const response = await apiCommonRaw<BlobPart>(`${groupPrefix}/${orderId}/${SHIPMENT_PREFIX}/label`, {
			method: 'GET',
			responseType: 'blob',
		})

		downloadFileFromResponse(response, 'shipment-label.pdf')
	},
	generateGadgetsOrderShipment: async (orderId: number): Promise<IGadgetOrderShipmentModel> => {
		const { data } = await apiCommon<IGadgetOrderShipment>(`${groupPrefix}/${orderId}/${SHIPMENT_PREFIX}`, {
			method: 'POST',
		})

		return GadgetsOrderShipment(data)
	},
	updateGadgetsOrdersShipmentStatusBulk: async (payload: IGadgetsOrdersShipmentStatusBulkPayload): Promise<void> => {
		await apiCommon(`${groupPrefix}/shipment-statuses`, {
			method: 'POST',
			body: { ...payload },
		})
	},
}
